import elLocale from 'element-ui/lib/locale/lang/el'
import home from './el/home'

const el = {
    language: 'Deutsch',
    message: {
        'home': home,
    },
    '手机号码最小长度为8位': 'Το ελάχιστο μήκος του αριθμού κινητού τηλεφώνου είναι 8 ψηφία',
    '邮箱账号名称最小长度为6位': 'Το ελάχιστο μήκος του ονόματος λογαριασμού email είναι 6 χαρακτήρες',
    '邮箱只能包含英文，数字等字符': 'Το γραμματοκιβώτιο μπορεί να περιέχει μόνο χαρακτήρες όπως αγγλικά και αριθμούς',
    '请选择正确的收货地址': 'Παρακαλώ επιλέξτε τη σωστή διεύθυνση αποστολής',
    ...elLocale
}

export default el